export default __webpack_public_path__ + "assets/ticketbutler_favicon-d7cdb34883c62a431e0d8d7f8f611ea6.png";